import { render, staticRenderFns } from "./erpProfile.vue?vue&type=template&id=a3b5fcd2&"
import script from "./erpProfile.vue?vue&type=script&lang=js&"
export * from "./erpProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports